import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { Card, CardBody, FormGroup, Label, Input, Button } from 'reactstrap';
import { Breadcrumbs, H6 } from '../../AbstractElements';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';

const DailyProgram = () => {
    const [loader, setLoader] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const token = useSelector(state => state.auth.userToken);
    const { id } = useParams();

    useEffect(() => {
        const fetchDailyData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/add/getDaily`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const dailyOptions = response.data.dailyWorkOut.map(item => ({
                    value: item._id,
                    label: item.workOutName,
                }));
                setOptions(dailyOptions);
            } catch (error) {
                console.error('Error fetching daily data:', error);
            }
        };

        fetchDailyData();
    }, [token]);

    useEffect(() => {
        const fetchDailyProgram = async () => {
            if (id) {
                setLoader(true);
                try {
                    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/add/getDailyObjById/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    const data = response.data;
                    setSearchTerm(data.workOutName);
                    setSelectedOptions(data.workoutIds.map(id => options.find(option => option.value === id)));
                    setLoader(false);
                } catch (error) {
                    console.error('Error fetching daily program:', error);
                    setLoader(false);
                }
            }
        };

        fetchDailyProgram();
    }, [id, token, options]);

    const handleSearchChange = inputValue => {
        setSearchTerm(inputValue);
    };

    const handleSubmit = async () => {
        setLoader(true);

        try {
            const dailyIds = selectedOptions.map(option => option.value);
            const requestBody = {
                workOutName: searchTerm,
                workoutIds: dailyIds,
            };
            let config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const response = id
                ? await axios.put(`${process.env.REACT_APP_API_BASE_URL}/add/editDailyWhole/${id}`, requestBody, config)
                : await axios.post(`${process.env.REACT_APP_API_BASE_URL}/add/addDailyObj`, requestBody, config);

            if (response.status === 200 || response.status === 201) {
                toast.success(response.data.message);
                setLoader(false);
                setSelectedOptions([]);
                setSearchTerm("");
            }
        } catch (error) {
            console.error('Error submitting daily object:', error);
            setLoader(false);
        }
    };

    const handleSelectChange = selectedOptions => {
        setSelectedOptions(selectedOptions);
    };

    return (
        <div>
            <Breadcrumbs mainTitle="Daily Program" parent="Admin" title="Manage Daily Program" />

            {!loader ? (
                <Card>
                    <CardBody>
                        <H6>{id ? "Edit Daily Program" : "Add Daily Program"}</H6>

                        <FormGroup>
                            <Label htmlFor="searchWorkout">Enter Workout:</Label>
                            <Input
                                type="text"
                                id="searchWorkout"
                                placeholder="Enter workout name..."
                                value={searchTerm}
                                onChange={e => handleSearchChange(e.target.value)}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label htmlFor="selectWorkouts">Select Workouts:</Label>
                            <Select
                                id="selectWorkouts"
                                options={options}
                                isMulti
                                onChange={handleSelectChange}
                                value={selectedOptions}
                                placeholder="Select daily workouts..."
                                noOptionsMessage={() => 'No options found'}
                            />
                        </FormGroup>

                        <Button color="success" onClick={handleSubmit}>
                            {id ? 'Edit Daily Program' : 'Add Daily Program'}
                        </Button>
                    </CardBody>
                </Card>
            ) : (
                <div>Loading...</div>
            )}
        </div>
    );
};

export default DailyProgram;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import Select from 'react-select';
// import { Card, CardBody, Form, FormGroup, Label, Input, Button, Container, Row, Col } from 'reactstrap';
// import { Breadcrumbs, Btn, H6 } from '../../AbstractElements';
// import { useSelector } from "react-redux";
// import { toast } from 'react-toastify';
// import { useParams } from 'react-router';

// const DailyProgram = () => {
//   const [loader, setLoader] = useState(false);
//   const [options, setOptions] = useState([]);
//   const [selectedOptions, setSelectedOptions] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const token = useSelector((state) => state.auth.userToken);
//   const { id } = useParams();

//   // useEffect(() => {


//   //   const fetchDailyProgram = async () => {
//   //     if (id) {
//   //       setLoader(true);
//   //       try {
//   //         const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/add/getDailyObjById/${"65f88b226001471c958c3be6"}`, {
//   //           headers: {
//   //             Authorization: `Bearer ${token}`,
//   //           },
//   //         });
//   //         const data = response.data;
//   //         setSearchTerm(data.workOutName);
//   //         setSelectedOptions(data.workoutIds.map(id => options.find(option => option.value === id)));
//   //         setLoader(false);
//   //       } catch (error) {
//   //         console.error('Error fetching daily program:', error);
//   //         setLoader(false);
//   //       }
//   //     }
//   //   };


//   //   fetchDailyProgram();
//   // }, [id, token, options]);

//   useEffect(() => {

  
//     const fetchDailyProgram = async () => {
//       if (id) {
//         setLoader(true);
//         try {
//           const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/add/getDailyObjById/${"65f88b226001471c958c3be6"}`, {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           });
//           const data = response.data;
//           setSearchTerm(data.workOutName);
//           setSelectedOptions(data.workoutIds.map(id => options.find(option => option.value === id)));
//           setLoader(false);
//         } catch (error) {
//           console.error('Error fetching daily program:', error);
//           setLoader(false);
//         }
//       }
//     };
  
//     fetchDailyProgram();
//   }, [id, token, options]);
//     const handleSearchChange = inputValue => {
//     setSearchTerm(inputValue);
//   };

//   const handleSubmit = async () => {
//     setLoader(true);

//     try {
//       const dailyIds = selectedOptions.map(option => option.value);
//       const requestBody = {
//         workOutName: searchTerm,
//         workoutIds: dailyIds,
//       };
//       let config = {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       };

//       const response = id
//         ? await axios.put(`${process.env.REACT_APP_API_BASE_URL}/add/editDailyObj/${id}`, requestBody, config)
//         : await axios.post(`${process.env.REACT_APP_API_BASE_URL}/add/addDailyObj`, requestBody, config);

//       if (response.status === 200 || response.status === 201) {
//         toast.success(response.data.message);
//         setLoader(false);
//         setSelectedOptions([]);
//         setSearchTerm("");
//       }
//     } catch (error) {
//       console.error('Error submitting daily object:', error);
//       setLoader(false);
//     }
//   };

//   const handleSelectChange = selectedOptions => {
//     setSelectedOptions(selectedOptions);
//   };

//   return (
//     <div>
//       <Breadcrumbs mainTitle="Daily Program" parent="Admin" title="Manage Daily Program" />
//       {!loader ? (
//         <Container fluid={true}>
//           <H6>{id ? "Edit Daily Program" : "Add Daily Program"}</H6>
//           <Row>
//             <Col sm="12">
//               <Card>
//                 <CardBody>
//                   <Form>
//                     <FormGroup>
//                       <Label htmlFor="searchWorkout">Enter Workout:</Label>
//                       <Input
//                         type="text"
//                         id="searchWorkout"
//                         placeholder="Enter workout name..."
//                         value={searchTerm}
//                         onChange={e => handleSearchChange(e.target.value)}
//                       />
//                     </FormGroup>
//                     <FormGroup>
//                       <Label htmlFor="selectWorkouts">Select Workouts:</Label>
//                       <Select
//                         id="selectWorkouts"
//                         options={options}
//                         isMulti
//                         onChange={handleSelectChange}
//                         value={selectedOptions}
//                         placeholder="Select daily workouts..."
//                         noOptionsMessage={() => 'No options found'}
//                       />
//                     </FormGroup>
//                     <div className="text-end">
//                       <Btn
//                         attrBtn={{
//                           color: "success",
//                           className: "me-3",
//                           onClick: handleSubmit,
//                         }}
//                       >
//                         {id ? "Edit Daily Program" : "Add Daily Program"}
//                       </Btn>
//                     </div>
//                   </Form>
//                 </CardBody>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       ) : (
//         <div>Loading...</div>
//       )}
//     </div>
//   );
// };

// export default DailyProgram;

// // import React, { useState, useEffect } from 'react';
// // import axios from 'axios';
// // import Select from 'react-select';
// // import { Card, CardBody, Col, Row, Form, FormGroup, Label, Input, Button } from 'reactstrap';
// // import { Breadcrumbs, Btn, H6 } from '../../AbstractElements';
// // import HeaderCard from '../../myComponents/HeaderCard';
// // import { useSelector } from "react-redux";
// // import { toast } from 'react-toastify';
// // import { useParams } from 'react-router';

// // const DailyProgram = () => {
// //   const [loader, setLoader] = useState(false);
// //   const [options, setOptions] = useState([]);
// //   const [selectedOptions, setSelectedOptions] = useState([]);
// //   const [searchTerm, setSearchTerm] = useState('');
// //   const token = useSelector((state) => state.auth.userToken);
// //   const { id } = useParams();

// //   useEffect(() => {
// //     const fetchDailyData = async () => {
// //       try {
// //         const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/add/getDaily`);
// //         const dailyOptions = response.data.dailyWorkOut.map(item => ({
// //           value: item._id,
// //           label: item.workOutName,
// //         }));
// //         setOptions(dailyOptions);
// //       } catch (error) {
// //         console.error('Error fetching daily data:', error);
// //       }
// //     };

// //     const fetchDailyProgram = async () => {
// //       if (id) {
// //         setLoader(true);
// //         try {
// //           const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/add/getDaily/${id}`, {
// //             headers: {
// //               Authorization: `Bearer ${token}`,
// //             },
// //           });
// //           const data = response.data;
// //           setSearchTerm(data.workOutName);
// //           setSelectedOptions(data.workoutIds.map(id => options.find(option => option.value === id)));
// //           setLoader(false);
// //         } catch (error) {
// //           console.error('Error fetching daily program:', error);
// //           setLoader(false);
// //         }
// //       }
// //     };

// //     // fetchDailyData();
// //     // fetchDailyProgram();
// //   }, [id, token, options]);

// //   const handleSearchChange = inputValue => {
// //     setSearchTerm(inputValue);
// //   };

// //   const handleSubmit = async () => {
// //     setLoader(true);

// //     try {
// //       const dailyIds = selectedOptions.map(option => option.value);
// //       const requestBody = {
// //         workOutName: searchTerm,
// //         workoutIds: dailyIds,
// //       };
// //       let config = {
// //         headers: {
// //           Authorization: `Bearer ${token}`,
// //         },
// //       };

// //       const response = id
// //         ? await axios.put(`${process.env.REACT_APP_API_BASE_URL}/add/editDailyObj/${id}`, requestBody, config)
// //         : await axios.post(`${process.env.REACT_APP_API_BASE_URL}/add/addDailyObj`, requestBody, config);

// //       if (response.status === 200 || response.status === 201) {
// //         toast.success(response.data.message);
// //         setLoader(false);
// //         setSelectedOptions([]);
// //         setSearchTerm("");
// //       }
// //     } catch (error) {
// //       console.error('Error submitting daily object:', error);
// //       setLoader(false);
// //     }
// //   };

// //   const handleSelectChange = selectedOptions => {
// //     setSelectedOptions(selectedOptions);
// //   };

// //   return (
// //     <div>
// //       <Breadcrumbs mainTitle="Daily Program" parent="Admin" title="Manage Daily Program" />
// //       {!loader ? (
// //         <Card>
// //           <HeaderCard title="Daily Program" />
// //           <CardBody>
// //             <Form>
// //               <FormGroup>
// //                 <Label htmlFor="searchWorkout">Enter Workout:</Label>
// //                 <Input
// //                   type="text"
// //                   id="searchWorkout"
// //                   placeholder="Enter workout name..."
// //                   value={searchTerm}
// //                   onChange={e => handleSearchChange(e.target.value)}
// //                 />
// //               </FormGroup>
// //               <FormGroup>
// //                 <Label htmlFor="selectWorkouts">Select Workouts:</Label>
// //                 <Select
// //                   id="selectWorkouts"
// //                   options={options}
// //                   isMulti
// //                   onChange={handleSelectChange}
// //                   value={selectedOptions}
// //                   placeholder="Select daily workouts..."
// //                   noOptionsMessage={() => 'No options found'}
// //                 />
// //               </FormGroup>
// //               <Button color="success" onClick={handleSubmit}>
// //                 {id ? "Edit Daily Program" : "Add Daily Program"}
// //               </Button>
// //             </Form>
// //           </CardBody>
// //         </Card>
// //       ) : (
// //         <div>Loading...</div>
// //       )}
// //     </div>
// //   );
// // };

// // export default DailyProgram;
